module.exports = __webpack_public_path__ + "static/il-glass-145c31ae8d1ca1f0459e4bd0eac9094e.svg";